module.exports = __webpack_public_path__ + "img/prop1.901e0831.svg";